import React from 'react';
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';

const Contacts: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(routes.main);
  };

  return (
    <ContentLayout size="small">
      <Text type="h2" className={styles['title']}>Контакты</Text>
      <Text type="p">
        <Text type="span" muted>Адрес:</Text>
        <br />
        127434, г. Москва, шоссе Дмитровское, д. 9 этаж / ком. 3/63
      </Text>
      <Text type="p">
        <Text type="span" muted>Телефон:</Text>
        <br />
        +7 (495) 258-44-08
      </Text>
      <Text type="p">
        <Text type="span" muted>E-mail:</Text>
        <br />
        <a href="mailto: sbp@1c.ru">sbp@1c.ru</a>
      </Text>
      <div className={styles['button-wrapper']}>
        <Button variant="outlined" onClick={handleClick} >
          На Главную
        </Button>
      </div>
    </ContentLayout>
  );
};

export default Contacts;
